const config = {
    palleteImagePath: "/Settings/pallete.png", 
    palletePrintImagePath: "/Settings/palletePrint.png",
    testPath: "./Settings/test.png"
  };
  
  export default config;